export default "__VITE_ASSET__Ce3mFQO1__"